import { useHistory } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
export const useRedirectToProposal = ()=>{
    const history = useHistory();
    const overlayContext = useOverlayContext();
    const { updateUserClientData, logBI } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const redirectToProposal = async (proposalType, draftId, state)=>{
        try {
            overlayContext.startLoader('temp');
            await updateUserClientData({
                lastSelectedProposal: proposalType
            });
            overlayContext.stopLoader('temp');
            const studioPath = draftId ? routes.draft(draftId) : routes.agreementStudio;
            switch(proposalType){
                case 'agreement':
                    logBI(10350, {});
                    history.push(studioPath, state);
                    break;
                case 'invite':
                    logBI(10353, {});
                    history.push("".concat(studioPath, "/existing-client"), state);
                    break;
            }
        } catch (e) {
            overlayContext.stopLoader('temp');
            overlayContext.showErrorToast(commonTexts.toasts.failedToCreateProposal(), 'create-proposal-error-toast');
        }
    };
    const openCreationModal = async (draftIdGetter, state)=>{
        if (typeof draftIdGetter !== 'undefined') {
            const draftId = await draftIdGetter('agreement');
            await redirectToProposal('agreement', draftId, state);
        } else {
            await redirectToProposal('agreement', undefined, state);
        }
    };
    return {
        openCreationModal,
        redirectToProposal
    };
};
